import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-431ee482"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "content-back"
};
const _hoisted_4 = {
  class: "head-menu"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "item-back"
};
const _hoisted_8 = {
  class: "share-main"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc-text"
}, "·邀请好友开通会员，获得50%会员费返利", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "desc-text"
}, "·邀请女性完成女神认证，获得10元现金奖励", -1));

const _hoisted_11 = {
  class: "btn-back"
};
const _hoisted_12 = ["src"];

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "share-text"
}, "分享链接", -1));

const _hoisted_14 = ["src"];

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "share-text"
}, "分享海报", -1));

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-word-mid"
}, "邀请步骤", -1));

const _hoisted_17 = {
  class: "item-back"
};
const _hoisted_18 = {
  class: "share-back"
};
const _hoisted_19 = {
  class: "share-item"
};
const _hoisted_20 = ["src"];

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 复制链接或");

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 海报给好友 ");

const _hoisted_24 = {
  class: "share-item"
};
const _hoisted_25 = ["src"];

const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 好友下载后开通会");

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 员或完成女生认证 ");

const _hoisted_29 = {
  class: "share-item"
};
const _hoisted_30 = ["src"];

const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 现金奖励");

const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 自动到账 ");

const _hoisted_34 = {
  class: "title-word"
};

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "邀请记录", -1));

const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 提现 ");

const _hoisted_37 = ["src"];
const _hoisted_38 = {
  class: "item-back"
};
const _hoisted_39 = {
  class: "share-back"
};
const _hoisted_40 = {
  class: "inv-count-back"
};
const _hoisted_41 = {
  class: "big-price"
};

const _hoisted_42 = /*#__PURE__*/_createTextVNode("人 ");

const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inv-desc-text"
}, "已邀请", -1));

const _hoisted_44 = ["src"];
const _hoisted_45 = {
  class: "inv-count-back"
};
const _hoisted_46 = {
  class: "big-price"
};

const _hoisted_47 = /*#__PURE__*/_createTextVNode("元 ");

const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inv-desc-text"
}, "已获得奖励", -1));

const _hoisted_49 = ["src"];

const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title-word-mid"
}, [/*#__PURE__*/_createElementVNode("div", null, "现金奖励排行榜")], -1));

const _hoisted_51 = {
  class: "list-main"
};
const _hoisted_52 = {
  class: "list-back"
};
const _hoisted_53 = {
  class: "list-left"
};
const _hoisted_54 = {
  class: "number-back"
};
const _hoisted_55 = ["src"];
const _hoisted_56 = {
  class: "nickname"
};
const _hoisted_57 = {
  key: 0,
  class: "bottom-tips"
};

const _hoisted_58 = /*#__PURE__*/_createTextVNode(" 分享即代表同意");

const _hoisted_59 = /*#__PURE__*/_createTextVNode("《分享协议》");

const _hoisted_60 = /*#__PURE__*/_createTextVNode("和");

const _hoisted_61 = /*#__PURE__*/_createTextVNode("《分享推广规范》");

const _hoisted_62 = {
  key: 1,
  class: "bottom-tips"
};

const _hoisted_63 = /*#__PURE__*/_createTextVNode(" 分享即代表同意");

const _hoisted_64 = /*#__PURE__*/_createTextVNode("《分享协议》");

const _hoisted_65 = /*#__PURE__*/_createTextVNode("和");

const _hoisted_66 = /*#__PURE__*/_createTextVNode("《分享推广规范》");

const _hoisted_67 = {
  key: 2,
  class: "tips-hide"
};
const _hoisted_68 = {
  key: 3,
  class: "tips-back"
};
const _hoisted_69 = {
  class: "tips-main"
};
const _hoisted_70 = ["src"];

const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "rule-title"
}, "规则说明", -1));

const _hoisted_72 = /*#__PURE__*/_createTextVNode(" 1、邀请女神认证后3日内都无违规行为，即可获得10元现金奖励");

const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 2、通过链接、二维码邀请男性用户注册，先送一张微信解锁券，且被邀请男性首次开通会员，您可以获得充值金额50%的现金奖励");

const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 3、进制以任何形式刷奖励，同一个设备和同IP视为一个用户，不能通过邀请自己的方式获取返利");

const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_78 = /*#__PURE__*/_createTextVNode(" 4、邀请奖励满200元才可以提现，7个工作日到账");

const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 5、因终身会员是限时特价活动，不参与邀请好友返现金活动，邀请用户开通终身会员不会返利");

const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_82 = /*#__PURE__*/_createTextVNode(" 6、小圈官方拥有最终解释权");

const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    src: $setup.BackHead,
    class: "back-head"
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $setup.Back,
    class: "back-icon",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.back && $setup.back(...args))
  }, null, 8, _hoisted_5), _createElementVNode("div", {
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.showTips && $setup.showTips(...args))
  }, "规则")]), _createElementVNode("img", {
    src: $setup.Word,
    class: "big-word"
  }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "share-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.link && $setup.link(...args))
  }, [_createElementVNode("img", {
    src: $setup.Share,
    class: "btn-icon"
  }, null, 8, _hoisted_12), _hoisted_13]), _createElementVNode("div", {
    class: "share-btn",
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.haibao && $setup.haibao(...args))
  }, [_createElementVNode("img", {
    src: $setup.Share,
    class: "btn-icon"
  }, null, 8, _hoisted_14), _hoisted_15])])])]), _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
    src: $setup.LinkQuan,
    class: "share-icon"
  }, null, 8, _hoisted_20), _hoisted_21, _hoisted_22, _hoisted_23]), _createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
    src: $setup.FriendQuan,
    class: "share-icon"
  }, null, 8, _hoisted_25), _hoisted_26, _hoisted_27, _hoisted_28]), _createElementVNode("div", _hoisted_29, [_createElementVNode("img", {
    src: $setup.PriceQuan,
    class: "share-icon"
  }, null, 8, _hoisted_30), _hoisted_31, _hoisted_32, _hoisted_33])])]), _createElementVNode("div", _hoisted_34, [_hoisted_35, _createVNode(_component_router_link, {
    to: {
      name: 'CashPage'
    },
    class: "more-back"
  }, {
    default: _withCtx(() => [_hoisted_36, _createElementVNode("img", {
      src: $setup.More,
      class: "more-icon"
    }, null, 8, _hoisted_37)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_41, _toDisplayString($setup.info.count), 1), _hoisted_42]), _createElementVNode("div", {
    class: "inv-desc",
    onClick: _cache[4] || (_cache[4] = $event => $setup.router.push({
      name: 'InviteRecord'
    }))
  }, [_hoisted_43, _createElementVNode("img", {
    src: $setup.More,
    class: "more-icon"
  }, null, 8, _hoisted_44)])]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_46, _toDisplayString($setup.info.money), 1), _hoisted_47]), _createElementVNode("div", {
    class: "inv-desc",
    onClick: _cache[5] || (_cache[5] = $event => $setup.router.push({
      name: 'InviteRecord'
    }))
  }, [_hoisted_48, _createElementVNode("img", {
    src: $setup.More,
    class: "more-icon"
  }, null, 8, _hoisted_49)])])])]), _hoisted_50, _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "list-item",
      key: index
    }, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, _toDisplayString(index + 1), 1), _createElementVNode("img", {
      src: item.avatar,
      class: "list-img"
    }, null, 8, _hoisted_55), _createElementVNode("span", _hoisted_56, _toDisplayString(item.nickName), 1)]), _createElementVNode("div", null, _toDisplayString(item.sumMoney) + "元", 1)]);
  }), 128))])]), $setup.yue ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_hoisted_58, _createVNode(_component_router_link, {
    class: "links",
    to: {
      name: 'ShareUserAgreements'
    }
  }, {
    default: _withCtx(() => [_hoisted_59]),
    _: 1
  }), _hoisted_60, _createVNode(_component_router_link, {
    class: "links",
    to: {
      name: 'ShareUserRules'
    }
  }, {
    default: _withCtx(() => [_hoisted_61]),
    _: 1
  })])) : (_openBlock(), _createElementBlock("div", _hoisted_62, [_hoisted_63, _createVNode(_component_router_link, {
    class: "links",
    to: {
      name: 'ShareUserAgreement'
    }
  }, {
    default: _withCtx(() => [_hoisted_64]),
    _: 1
  }), _hoisted_65, _createVNode(_component_router_link, {
    class: "links",
    to: {
      name: 'ShareUserRule'
    }
  }, {
    default: _withCtx(() => [_hoisted_66]),
    _: 1
  })])), $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_67)) : _createCommentVNode("", true), $setup.show ? (_openBlock(), _createElementBlock("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("img", {
    src: $setup.Close,
    class: "close-icon",
    onClick: _cache[6] || (_cache[6] = (...args) => $setup.closeTip && $setup.closeTip(...args))
  }, null, 8, _hoisted_70), _hoisted_71, _hoisted_72, _hoisted_73, _hoisted_74, _hoisted_75, _hoisted_76, _hoisted_77, _hoisted_78, _hoisted_79, _hoisted_80, _hoisted_81, _hoisted_82, _hoisted_83])])) : _createCommentVNode("", true)]);
}